// extracted by css-extract-rspack-plugin
export default {"cls1":"ArticlesFilters-cls1_GdO","cls2":"ArticlesFilters-cls2_Muw ArticlesFilters-cls1_GdO"};